
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent12 as ObiWindApparent12Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-12.js';
 
 
 

 
 export const ObiWindApparent12 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-12',
   elementClass: ObiWindApparent12Element,
   events: {
     
   }
  });
 
 